import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from './constants';
import { Jurisdiction } from 'types/jurisdiction';

const url = `${baseApiUrl()}/lexiverse/jurisdictions/v1/jurisdictions`;

export const getJurisdictions = async (onError?: (errors: ServerErrorResponse) => void) => {
  try {
    const data = await fetcher({
      method: 'get',
      url,
    });
    return data;
  } catch (error: unknown) {
    if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
      onError(error as ServerErrorResponse);
    }
    throw error;
  }
};

export default function useJurisdictions(options = {}, onError?: (errors: ServerErrorResponse) => void) {
  return useQuery<Jurisdiction[], ServerErrorResponse>(['jurisdictions'], async () => getJurisdictions(onError), {
    keepPreviousData: false,
    ...options,
  });
}
